export function Lego() {
  return (
    <svg
      width="65"
      height="63"
      viewBox="0 0 65 63"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.5"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.3545 3.76136C13.3545 1.70235 15.0236 0.0332031 17.0826 0.0332031H23.9176C25.9766 0.0332031 27.6458 1.70236 27.6458 3.76136V10.5963C27.6458 12.6553 25.9766 14.3245 23.9176 14.3245H17.0826C15.0236 14.3245 13.3545 12.6553 13.3545 10.5963V3.76136Z"
        fill="currentColor"
      />
      <path
        opacity="0.5"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M38.209 3.76136C38.209 1.70235 39.8781 0.0332031 41.9371 0.0332031H48.7721C50.8311 0.0332031 52.5002 1.70236 52.5002 3.76136V10.5963C52.5002 12.6553 50.8311 14.3245 48.7721 14.3245H41.9371C39.8781 14.3245 38.209 12.6553 38.209 10.5963V3.76136Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M57.4714 10.5957C61.5894 10.5957 64.9277 13.934 64.9277 18.052V54.7122C64.9277 58.8302 61.5894 62.1685 57.4714 62.1685H8.38404C4.26603 62.1685 0.927734 58.8302 0.927734 54.7122L0.927734 18.052C0.927734 13.934 4.26604 10.5957 8.38405 10.5957L57.4714 10.5957Z"
        fill="currentColor"
      />
    </svg>
  );
}
